module.exports = __webpack_public_path__ + "img/00-plan-a.50fc6c73.png";